import Airtable from 'airtable';

// api keys are confidential
const base = new Airtable({ apiKey: process.env.REACT_APP_AIRTABLE_API_KEY }).base(
  'appHxco1A4qoubNPU'
);

export default base;